import React, { useState } from "react";
import CreateSubscriptionForm from "./CreateSubscriptionForm";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import ReactHotToaster from "../../common/ReactHotToaster";
import { axiosConfig } from "../../../axios/axiosConfig";
import SubscriptionPlansTable from "./SubscriptionPlansTable";
import MuiModal from "../../muiComps/MuiModal";
import MuiLoadingSpinner from "../../common/MuiLoadingSpinner";
import { Box, Button, Typography } from "@mui/material";
import LayersIcon from "@mui/icons-material/Layers";
import AddOnData from "./AddOnData";

const SubscriptionsPlans = () => {
  const [allPlanDetails, setAllPlanDetails] = useState([]);
  const [addOnData, setAddOnData] = useState([]);
  const [openSubscriptionForm, setOpenSubscriptionForm] = useState(false);
  const [activePlan, setActivePlan] = useState({});

  // fetch all subscription plans
  const fetchAllPlansQuery = useQuery({
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    refetchInterval: false, // Disable automatic refetching
    queryKey: ["all-plans"], // dependency
    queryFn: () => fetchAllPlans(),
    onSuccess: (data) => {
      // Using flatMap to combine all `data` arrays from `response.plans`
      const newArray = data.response.plans.flatMap((plan) => plan.data);
      const addOnArray =
        data?.response?.addondata?.flatMap((addon) => addon?.data) || [];
      setAddOnData(addOnArray);
      setAllPlanDetails(newArray);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });


  const openCreateSubscriptionModals = () => {
    setActivePlan({}); // Reset active plan when opening the modal
    setOpenSubscriptionForm(true);
  };
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <LayersIcon sx={{ color: "#fff", fontSize: 32 }} />
          <Box>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
              Subscription Plans
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
              Manage subscription and add-on plans
            </Typography>
          </Box>
        </Box>
        <Button
          onClick={openCreateSubscriptionModals}
          sx={{
            background: "linear-gradient(135deg, #016551, #014d3d)",
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
            "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
          }}
        >
          Create Subscription Plan
        </Button>
      </Box>

      {/* Tables */}
      {fetchAllPlansQuery?.isLoading ? (
        <MuiLoadingSpinner />
      ) : (
        <>
          <SubscriptionPlansTable
            plansData={allPlanDetails}
            setOpenSubscriptionForm={setOpenSubscriptionForm}
            setActivePlan={setActivePlan}
          />
          <AddOnData
            addOnData={addOnData}
            setOpenSubscriptionForm={setOpenSubscriptionForm}
            setActivePlan={setActivePlan}
          />
        </>
      )}

      {/* subscription form modal */}
      <MuiModal open={openSubscriptionForm} setOpen={setOpenSubscriptionForm}>
        <CreateSubscriptionForm
          key={activePlan?.id || "create"}
          formType={Object.keys(activePlan).length ? "edit" : "create"}
          activePlan={activePlan}
          setAllPlanDetails={setAllPlanDetails}
          setOpenSubscriptionForm={setOpenSubscriptionForm}
        />
      </MuiModal>

      {/* REACT HOT TOAST */}
      <ReactHotToaster />
    </Box>
  );
};

export default SubscriptionsPlans;

// UTILITY FUNCTIONS
export const fetchAllPlans = async () => {
  // if (!USERID) return;

  const res = await axiosConfig({
    method: "get",
    url: `/subscription/subscription_plan`,
    data: {},
  });

  return res.data;
};
